import { useFormikContext } from 'formik'
import i18n from 'core/common/i18n'
import convertDecimalPlaces from 'core/common/utils/convertDecimalPlaces'
import {
  DIMENSION_OPTIONS,
  PACKAGE_OPTIONS,
  ProductFreightV2Values,
  WEIGHT_OPTIONS,
} from '../constants'
import CustomSelect from './CustomSelect'

interface ControlFormProps {
  selectedDimension: string
  selectedWeight: string
  selectedPackage: string
  onChangeWeight: (value: string) => void
  onChangeDimension: (value: string) => void
  onChangePackage: (value: string) => void
}

const ControlFrom = ({
  selectedDimension,
  selectedWeight,
  selectedPackage,
  onChangeWeight,
  onChangeDimension,
  onChangePackage,
}: ControlFormProps) => {
  const { handleChange, setFieldValue, setValues, values } =
    useFormikContext<ProductFreightV2Values>()

  const handleChangeWeight = (value: string) => {
    onChangeWeight(value)

    if (value === 'kg') {
      values.variations?.forEach((variation, index) =>
        setFieldValue(
          `variations.${index}.package.weight.value`,
          convertDecimalPlaces((values.variations?.[index]?.package?.weight?.value || 0) / 1000)
        )
      )

      setFieldValue(
        'package.weight.value',
        convertDecimalPlaces((values.package.weight?.value || 0) / 1000)
      )

      return
    }

    values.variations?.forEach((variation, index) =>
      setFieldValue(
        `variations.${index}.package.weight.value`,
        convertDecimalPlaces((values.variations?.[index]?.package?.weight?.value || 0) * 1000)
      )
    )

    setFieldValue(
      'package.weight.value',
      convertDecimalPlaces((values.package.weight?.value || 0) * 1000)
    )
  }

  const handleChangeDimension = (value: string) => {
    onChangeDimension(value)

    if (value === 'm') {
      setValues({
        ...values,
        package: {
          ...values.package,
          depth: convertDecimalPlaces(values.package.depth / 100),
          height: convertDecimalPlaces(values.package.height / 100),
          width: convertDecimalPlaces(values.package.width / 100),
        },
        variations: values.variations?.map(variation => ({
          ...variation,
          package: {
            ...variation.package,
            depth: convertDecimalPlaces(variation.package.depth / 100),
            height: convertDecimalPlaces(variation.package.height / 100),
            width: convertDecimalPlaces(variation.package.width / 100),
          },
        })),
      })

      return
    }

    setValues({
      ...values,
      package: {
        ...values.package,
        depth: convertDecimalPlaces(values.package.depth * 100),
        height: convertDecimalPlaces(values.package.height * 100),
        width: convertDecimalPlaces(values.package.width * 100),
      },
      variations: values.variations?.map(variation => ({
        ...variation,
        package: {
          ...variation.package,
          depth: convertDecimalPlaces(variation.package.depth * 100),
          height: convertDecimalPlaces(variation.package.height * 100),
          width: convertDecimalPlaces(variation.package.width * 100),
        },
      })),
    })
  }

  return (
    <div className="d-flex flex-row mb-4" style={{ gap: 16 }}>
      <CustomSelect
        id="product-freight-select-weightUn"
        name="weightUn"
        label={i18n.t('productNew.logistic.weightLabel')}
        options={WEIGHT_OPTIONS}
        value={selectedWeight}
        onSelect={handleChangeWeight}
        handleChange={handleChange}
      />

      <CustomSelect
        id="product-freight-select-dimensionUn"
        name="dimensionUn"
        label={i18n.t('productNew.logistic.dimensionLabel')}
        options={DIMENSION_OPTIONS}
        value={selectedDimension}
        onSelect={handleChangeDimension}
        handleChange={handleChange}
        disabled={selectedPackage === 'standard'}
      />

      <CustomSelect
        id="product-freight-select-standard_package"
        name="package.standard_package"
        label={i18n.t('productNew.logistic.packageLabel')}
        options={PACKAGE_OPTIONS}
        value={selectedPackage}
        onSelect={onChangePackage}
        handleChange={handleChange}
      />
    </div>
  )
}

export default ControlFrom
